module.exports = __webpack_public_path__ + "img/ul410.af69e90b.jpg";